import App from "../App";

export default class PromiseHelpers {
    public static combineParallel<T>(promises: Promise<T>[]): Promise<T> {
        return new Promise((res) => {
            let promisesLeft = promises.length || 0;
            let resolve = () => {
                promisesLeft--;
                if (promisesLeft <= 0) {
                    res();
                }
            };
            if (!promisesLeft) {
                resolve();
            } else {
                promises.forEach((promise) => {
                    promise.then(() => {
                        resolve();
                    });
                });
            }
        });
    }

    public static tweenPromise<T>(
        target,
        duration,
        vars: gsap.TweenConfig
    ): Promise<T> {
        return new Promise((res) => {
            if (vars.onComplete) {
                let oldOnComplete = vars.onComplete;
                vars.onComplete = () => {
                    oldOnComplete();
                    res();
                };
            } else {
                vars["onComplete"] = () => {
                    res();
                };
            }
            App.timeline.to(target, duration, vars, App.timeline.time());
        });
    }

    public static animPromise<T>(
        anim:PIXI.extras.AnimatedSprite,
        loop = false
    ): Promise<T> {
        return new Promise((res) => {
            anim.loop = loop;
            anim.gotoAndPlay(0);
            if(loop) {
                anim.onLoop = () => {
                    res();
                };
            } else {

                anim.onComplete = () => {
                    res();
                };
            }

        });
    }
}
